import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const SLOT_STYLE = {
  head: { top: '-22%', left: '50%', transform: 'translateX(-50%)', fontSize: '0.45em' },
  face: { top: '28%', left: '50%', transform: 'translateX(-50%)', fontSize: '0.38em' },
  neck: { bottom: '2%', left: '50%', transform: 'translateX(-50%)', fontSize: '0.4em' },
  back: { top: '30%', right: '-22%', fontSize: '0.4em' },
  aura: { top: '-10%', left: '-18%', fontSize: '0.35em' },
};

export function HampusAvatar({ state, base = 48, testid = 'hampus-avatar' }) {
  if (!state) return <div className="text-5xl" aria-hidden>🐹</div>;
  const size = Math.round(base * state.stage.size);
  const equipped = state.outfits.filter((o) => state.equipped.includes(o.id));
  const headTaken = equipped.some((o) => o.slot === 'head');
  return (
    <div className="relative inline-block leading-none flex-shrink-0 animate-[bounce_3s_ease-in-out_infinite]" style={{ fontSize: size }} data-testid={testid} title={state.stage.name}>
      <span aria-hidden>🐹</span>
      {state.stage.badge && (
        <span className="absolute" style={{ ...SLOT_STYLE.head, ...(headTaken ? { left: '78%', top: '-18%' } : {}) }} data-testid="hampus-badge">{state.stage.badge}</span>
      )}
      {equipped.map((o) => (
        <span key={o.id} className="absolute" style={SLOT_STYLE[o.slot]} data-testid={`hampus-wearing-${o.id}`}>{o.emoji}</span>
      ))}
    </div>
  );
}

export default function HampusWardrobe({ state, onChange }) {
  const [busy, setBusy] = useState(false);
  if (!state) return null;
  const toggle = async (id) => {
    const next = state.equipped.includes(id) ? state.equipped.filter((x) => x !== id) : [...state.equipped, id];
    if (next.length > 3) { toast('Hampus orkar bära max 3 saker 🐹'); return; }
    setBusy(true);
    try {
      const { data } = await axios.put(`${API}/hp-daily/hampus/outfit`, { equipped: next }, { withCredentials: true });
      onChange(data);
    } catch (e) { toast.error(e?.response?.data?.detail || 'Kunde inte byta outfit'); }
    setBusy(false);
  };
  const pct = state.next_stage ? Math.round(((state.days - state.stage.min_days) / (state.next_stage.min_days - state.stage.min_days)) * 100) : 100;

  return (
    <section className="neo-card p-4 bg-gradient-to-br from-[#FFF0E0] to-[#FFE8F5] space-y-3" data-testid="hampus-wardrobe">
      <div className="flex items-center gap-4">
        <HampusAvatar state={state} base={56} testid="hampus-wardrobe-avatar" />
        <div className="flex-1 min-w-0">
          <p className="text-[10px] font-bold tracking-[0.2em] uppercase opacity-60">Steg {state.stage_index + 1}/{state.stages.length} · {state.days} pluggdagar</p>
          <h4 className="font-['Fredoka'] font-bold text-lg" data-testid="hampus-stage-name">{state.stage.name}</h4>
          <div className="h-2 rounded-full bg-black/10 mt-1 overflow-hidden"><div className="h-full bg-[#F5B841] rounded-full transition-[width] duration-700" style={{ width: `${pct}%` }} /></div>
          <p className="text-[11px] opacity-70 mt-1" data-testid="hampus-next-stage">
            {state.next_stage ? `${state.days_to_next_stage} dagar kvar till ${state.next_stage.name}` : 'Fullvuxen student! 🎓'}
          </p>
        </div>
      </div>
      <div className="grid grid-cols-3 sm:grid-cols-6 gap-2">
        {state.outfits.map((o) => {
          const on = state.equipped.includes(o.id);
          return (
            <button key={o.id} disabled={!o.unlocked || busy} onClick={() => toggle(o.id)} data-testid={`hampus-outfit-${o.id}`}
              className={`rounded-xl border-2 p-2 text-center transition-transform ${on ? 'border-black bg-[#FFE8A3] scale-105' : 'border-black/15 bg-white'} ${o.unlocked ? 'hover:scale-105' : 'opacity-40'}`}>
              <div className="text-2xl">{o.unlocked ? o.emoji : '🔒'}</div>
              <div className="text-[10px] font-bold leading-tight">{o.name}</div>
              {!o.unlocked && <div className="text-[9px] opacity-60">dag {o.unlock_at}</div>}
            </button>
          );
        })}
      </div>
      <p className="text-[10px] opacity-60">{state.manual ? 'Du väljer själv vad Hampus har på sig.' : 'Hampus tar på sig det senaste han låst upp tills du väljer själv.'}</p>
    </section>
  );
}
